export const icons = {
    'python': 'fab',
    'c-sharp': '',
    'angular': 'fab',
    'react': 'fab',
    'sql': '',
    'mongo-db': '',
    'swift': 'fab',
    'micro-services': '',
    'rabbit-mq': '',
    'react-native': '',
    'html5': 'fab',
    'css3': 'fab',
    'bootstrap': 'fab'

 }